import { getMemberKeys } from 'Services/WeaverUtils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { WeaverLoading } from 'Components';

const nodeSelector = createSelector(
  (state) => state.graph.graphData.nodes,
  (nodes) => nodes
);

const edgeSelector = createSelector(
  (state) => state.graph.graphData.edges,
  (edges) => edges
);

const typeSelector = createSelector(
  (state) => state.explore.typesMap,
  (types) => types
);

const withFilterData = (WrappedComponent, getItems, itemSelector) => (props) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const nodes = useSelector(nodeSelector);
  const edges = useSelector(edgeSelector);
  const types = useSelector(typeSelector);
  const selectedItems = itemSelector ? useSelector(itemSelector) : undefined;

  const awaitAndSetItems = async () => {
    const updatedItems = await getItems({
      nodes,
      edges,
      memberKeys: getMemberKeys(),
      selectedItems,
      types: Object.values(types)
    });
    setItems(updatedItems);
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      await awaitAndSetItems();
    })()
  }, [nodes]);

  return (
    loading ? (
      <div style={{ display: 'flex', flex: '1 1 auto', alignItems: 'center', justifyContent: 'center' }}>
        <WeaverLoading style={{ width: '25%' }} />
      </div>
    ) : (
      <WrappedComponent items={items} {...props} />
    )
  );
};

export default withFilterData;
